export default __webpack_public_path__ + "static/media/login-image2.1c5ac05c.png";